import { connectRefinementList } from "instantsearch.js/es/connectors";
import { runAfterFrame } from "./helpers";

const PREDEFINED_MATERIAL_ORDER = ["Cuir", "Tissu", "Alcantara", "Simili cuir"];

export function createMaterialRefinementWidget(
    containerSelector: string,
    attribute: string,
) {
    const container = document.querySelector(containerSelector) as HTMLElement;
    if (!container) return null;

    const customRefinement = connectRefinementList<{ container: string }>(
        (renderOptions) => {
            const { items, refine } = renderOptions;

            let sorted = items.filter(
                (i) =>
                    i.value !== "Matériau Intérieur Indéfini" &&
                    i.value !== "Matériau intérieur indéfini",
            );

            const predefined = PREDEFINED_MATERIAL_ORDER.map((name) =>
                sorted.find((i) => i.label === name),
            ).filter((i): i is (typeof sorted)[number] => i !== undefined);
            const others = sorted.filter(
                (i) => !PREDEFINED_MATERIAL_ORDER.includes(i.label),
            );
            sorted = [...predefined, ...others];

            const hasSelected = sorted.some((i) => i.isRefined);

            container.innerHTML = `<div class="material-refinement-list"><div class="material-refinement-list__wrapper${
                hasSelected
                    ? " material-refinement-list__wrapper--has-selected"
                    : ""
            }">${sorted
                .map((item) => {
                    const disabled = item.count === 0 && !item.isRefined;
                    const classes = [
                        "material-refinement-list__item",
                        item.isRefined
                            ? "material-refinement-list__item--selected"
                            : "",
                        disabled
                            ? "material-refinement-list__item--disabled"
                            : "",
                    ]
                        .filter(Boolean)
                        .join(" ");
                    return `<label class="${classes}" data-attr="listing-panel-option">
                            <span>
                                <span class="material-refinement-list__label-text">${
                                    item.label
                                }</span>
                                <span class="material-refinement-list__count">(${item.count.toLocaleString("fr-FR")})</span>
                            </span>
                            <input type="checkbox" class="material-refinement-list__checkbox" data-value="${
                                item.value
                            }" ${item.isRefined ? "checked" : ""} ${
                                disabled ? "disabled" : ""
                            } />
                        </label>`;
                })
                .join("")}</div>${
                sorted.length === 0
                    ? '<span class="material-refinement-list__no-results">Aucun résultat</span>'
                    : ""
            }</div>`;

            container
                .querySelectorAll<HTMLInputElement>(
                    ".material-refinement-list__checkbox",
                )
                .forEach((cb) => {
                    cb.addEventListener("change", () => {
                        const val = cb.dataset.value;
                        if (val && !cb.disabled) runAfterFrame(() => refine(val));
                    });
                });
        },
    );

    return customRefinement({
        container: containerSelector,
        attribute,
        operator: "or" as const,
        limit: 100,
    });
}
